/**
 * AnniePainter — 2D Dark Child silhouette (red dress + bear silhouette cue).
 */
export const AnniePainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.9, 0, Math.PI * 2);
    ctx.fillStyle = '#b91c1c';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(0, -radius * 0.55, radius * 0.45, 0, Math.PI * 2);
    ctx.fillStyle = '#fde68a';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(radius * 0.85, radius * 0.2, radius * 0.35, 0, Math.PI * 2);
    ctx.fillStyle = '#7c2d12';
    ctx.fill();
  }
};
